<template>
  <b-modal
    id="withdraw-modal"
    ref="withdraw-modal"
    hide-footer
    no-close-on-backdrop
    title="ถอนเงิน"
    @show="resetModal"
    @hidden="resetModal"
  >
    <form
      ref="form"
      @submit.stop.prevent="handleSubmit"
    >

      <div class="mb-2">
        <span>บัญชี</span>
        <div class="withdraw-username text-center alert alert-info p-1"><h2 class="m-0">{{ username }}</h2></div>
      </div>
      <div class="mb-2">
        <span>ยอดคงเหลือ</span>
        <div class="withdraw-balance text-center alert alert-danger p-1"><h2 class="m-0">{{ balance }}</h2></div>
      </div>
      <b-form-group
        label="จำนวนเงิน"
      >
        <b-form-input
          name="amount"
          v-model="input.amount"
          type="number"
          size="lg"
          :number="true"
          required
        ></b-form-input>
      </b-form-group>

      <div class="d-flex justify-content-end mt-3 pt-3">
        <b-button variant="link" class="text-secondary mr-3" @click="hideModal">ยกเลิก</b-button>
        <b-button type="submit" variant="danger" :disabled="isProcess">{{isProcess ? 'กำลังถอนเงิน...' : 'ถอนเงิน'}}</b-button>
      </div>

    </form>
  </b-modal>
</template>
<script>
import AccountService from "@/services/accountService"
import Swal from 'sweetalert2'
import cryptoRandomString from 'crypto-random-string'

export default {
  name: 'WithdrawModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      account: null,
      input: {
        uniqueCode: '',
        amount: null
      },
      isProcess: false,
      needReload: false
    }
  },
  computed: {
    username() {
      if(this.data) {
        return this.data.users[0].username
      }else{
        return ''
      }
    },
    balance() {
      if(this.data) {
        return this.data.balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }else{
        return '0.00'
      }
    },
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    }
  },
  methods: {
    resetModal() {
      this.needReload = false
      this.input.amount = null
    },
    showModal() {
      this.input.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'});
      this.$refs['withdraw-modal'].show()
    },
    hideModal() {
      this.$refs['withdraw-modal'].hide()
    },
    handleSubmit() {

      if(this.data.balance < this.input.amount || this.input.amount < 0) {
        Swal.fire({
          title: 'จำนวนเงินไม่ถูกต้อง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        return
      }

      AccountService.withdraw(this.data._id, this.input)
      .then((response)=>{
        if(response.success) {
          this.needReload = true
          this.hideModal()
          this.$notify({
            type: 'success',
            title: 'สำเร็จ!',
            text: 'ถอนเงินเสร็จเรียบร้อย',
          })
        }else{
          throw new Error(response?.data)
        }
      })
      .catch((e)=>{
        Swal.fire({
          title: 'ผิดพลาด!',
          text: e?.message || 'ถอนเงินไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.input.uniqueCode = cryptoRandomString({length: 12, type: 'alphanumeric'})
      })
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
